import { PAGE_NAV_TITLE as SYSTEM_PAGE_NAV_TITLE } from "components/system-overview/bindings";
import HealthPage from "./HealthPage";
import HealthRoutes from "./Routes";
import HealthStatusBadge from "./HealthStatusBadge";
import useHealthModuleVisible, { HEALTH_MODULE_PERMISSIONS } from "./useHealthModuleVisible";
const healthBindings = {
  "navigation.badges": [
    {
      key: "org.graylog.plugins.health.HealthStatusBadge",
      component: HealthStatusBadge,
      useCondition: useHealthModuleVisible
    }
  ],
  routes: [{ path: HealthRoutes.unqualified.OVERVIEW, component: HealthPage, permissions: HEALTH_MODULE_PERMISSIONS }],
  pageNavigation: [
    {
      description: SYSTEM_PAGE_NAV_TITLE,
      children: [
        {
          description: "Health",
          path: HealthRoutes.OVERVIEW,
          position: { after: "Overview" },
          permissions: HEALTH_MODULE_PERMISSIONS,
          useCondition: useHealthModuleVisible
        }
      ]
    }
  ]
};
export default healthBindings;
